exports = module.exports = require("../../../../../node_modules/.0.28.9@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ckeditor{width:100%;clear:both}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.0.28.9@css-loader?minimize!./node_modules/.13.7.1@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e804602","scoped":false,"hasInlineConfig":false}!./node_modules/.13.7.1@vue-loader/lib/selector.js?type=styles&index=0!./src/packages/components/editor/components/ckeditor.vue
// module id = 65
// module chunks = 0 1